export const MY_CROPWISE_MODULE = "my-cropwise";
